import { EUserStatus, MessageModel, MessageReply } from '@/models'
import FormatDate from './FormatDate'
import { isChatSystemMessage } from './Common'

export const mappingChatMessage = (msg: any, userId: number): any => {
  const checkForTranslatedStatus = (msg: MessageModel) => {
    if (!msg?.is_html_content && msg?.file?.length) {
      return true
    }
    if (msg?.replyMessage?.content === 'chat_detail_message_deleted') {
      return true
    }
    if (msg?.content === 'chat_detail_message_deleted') {
      return true
    }
    if (isChatSystemMessage(msg?.content)) {
      return true
    }
    return false
  }

  let formatDate = ''

  let formatDateReply = ''
  let messageReply: MessageReply | null = null
  if (msg?.created_at) {
    formatDate = FormatDate.formatFullDatetime(msg.created_at)
  }
  if (msg?.reply_msg) {
    formatDateReply = FormatDate.formatFullDatetime(msg.created_at)
    messageReply = new MessageReply(msg, formatDateReply)
  }

  // check user login like msg
  let checkUserLike: boolean = false
  if (msg?.liker?.length > 0) {
    msg.liker.forEach((userLike: any) => {
      if (userLike.id === userId) {
        checkUserLike = true
      }
    })
  }

  return {
    messageId: msg?.id,
    content: msg?.content,
    senderId: msg?.sender_id,
    groupChatId: msg?.group_chat_id,
    userName: msg?.sender?.name,
    userAvatar:
      msg?.sender?.user_active_status === EUserStatus.LEAVE_SYSTEM
        ? ''
        : msg?.sender?.user_profile
        ? msg?.sender?.user_profile?.avatar
        : '',
    userStatus: msg?.sender?.user_active_status,
    timeSent: msg?.time_sent,
    formatDate,
    liker: msg?.liker || [],
    isLike: checkUserLike,
    isCanDelete: msg?.is_can_delete,
    replyMessage: messageReply,
    index: msg?.no_in_group_chat,
    messageSpecial: msg?.message_special,
    isOwnMsg: msg?.is_own_msg,
    file: msg?.file || [],
    is_html_content: msg?.is_html_content,
    deleted_at: msg?.deleted_at,
    usersRead: msg?.users_read || [],
    isTranslated: checkForTranslatedStatus(msg),
    content_translation: msg?.content_translation || ''
  }
}
